import React, { useEffect, useState } from "react";
import EventData from '../../Data/Admin/Viewapplicant.json';
import { Link,useParams} from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faXmark, faArrowLeftLong} from '@fortawesome/free-solid-svg-icons';
import { getApplicantsList, userStatusUpdate } from '../../Service';
import PaginatedItems from './Pagination';
import Swal from "sweetalert2";

export default function ViewApplication(){
let params = useParams();
const [eventList, setEventList] = React.useState([]);
const [perPage, setPerPage] = useState(10);
const [curPage, setCurPage] = useState(1);
const [dataCount, setDataCount]= useState('');
const [eventName, setEventName]= useState('');

useEffect(() => {
    let paramsDt = { 'perPage': perPage, 'curPage': curPage,event_id:params.id };
    getApplicantsList(paramsDt).then(res => handleResponse(res))
}, [curPage]);

const handleResponse = (response) => {
    //console.log('Exhibitor Listing',response)
    if(response.data.code==200){  //IF Request is Success
        setEventList(response.data.data.event_application.items);
        setDataCount(response.data.data.event_application.total);
        if(response.data.data.event_application.items.length){
            setEventName(response.data.data.event_application.items[0].event_name);
        }
        
    } else { //IF Token Expired......
        const errors = {};
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: response.data.message,
        })
    } 
}

const handleChange = (field, event) => {
    console.log('field change',field)
    console.log('event value change',event.target.value)
    let changedValue=event.target.value;
    let paramsUpdate={payment_id:field.payment_id,event_status:event.target.value}
    userStatusUpdate(paramsUpdate).then(res => handleResponseUpdate(res,changedValue))
}

const getEventApplication = () => {
    let paramsDt = { 'perPage': perPage, 'curPage': curPage,event_id:params.id };
    getApplicantsList(paramsDt).then(res => handleResponse(res))
}

const handleResponseUpdate = (response,changedValue) => {
    //console.log('Exhibitor Listing',response)
    let status='';

    if(changedValue === 'approve') { status= 'Approved' }
    else if(changedValue === 'reject') { status= 'Rejected' }
    else if(changedValue === 'pending') { status= 'Pending' }

    if(response.data.code==200){  //IF Request is Success
        Swal.fire({
            icon: 'success',
            title: 'Approval Status',
            text:  'Application has '+status ,
          })
          getEventApplication();
    } else { //IF Token Expired......
        const errors = {};
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: response.data.message,
        })
    } 
}


return(
        <section className="admin-section">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="card admin-table">
                            <div className="card-header">

                            <Link to="/eventlist"><FontAwesomeIcon icon={faArrowLeftLong} /> </Link>
                            <h1 style={{"text-align":"Center", "display": "grid" } }>{eventName}</h1>
                            </div>
                            <div className="card-body">
                                <div className="row requires-approval">
                                <div className="col-md-4">
                                <p>* Requires Approval / Action</p>
                                </div>
                                <div className="col-md-4">
                                <p style={{"text-align":"Center"}}>({dataCount}) Applicants</p>
                                </div>
                                <div className="col-md-4 ">
                                <Link to={ `/view_denied_application/${params.id}` }><p className="text-right">View Denied Applications</p></Link>
                                </div>
                                </div>
                            <br/>
                                <div className=" table-responsive">
                                    <table className="table applicant_table">
                                        <thead>
                                        <tr>
                                        <th>Status</th>
                                        <th>Gallery</th>
                                        <th>Application</th>
                                        <th>Primary Contact Name</th>
                                        <th>Email</th>
                                        <th>Phone</th>
                                        <th>Payment Status</th>
                                        <th></th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {
                                            eventList.length ?
                                            eventList.map( data => (
                                            <tr key={data}>
                                                <td>{data.event_status ? <select onChange={(event) => handleChange(data,event)} value={data.event_status} >
                                                    <option value="pending">Pending</option>
                                                    <option value="approve">Approve</option>
                                                    <option value="reject">Reject</option>
                                                    </select> : 'Application In Progress'}</td>
                                                <td>{data.gallery_name}</td>
                                                <td><Link to={ `/adminapplication/${data.id}` }>Application</Link></td>
                                                <td>{data.primary_contact_full_name}</td>
                                                <td>{data.billing_email}</td>
                                                <td>{data.phone}</td>
                                                <td>{data.payment_status}</td>            
                                            </tr> 
                                            ))
                                            : <tr>
                                                <td colSpan='3'>No Record Found</td>
                                            </tr>
                                        }
                                        </tbody>
                                    </table> 
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>  
        </section>
)
}
